import { render, staticRenderFns } from "./VideoContent.vue?vue&type=template&id=1ba73d8b&scoped=true"
import script from "./VideoContent.vue?vue&type=script&lang=js"
export * from "./VideoContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba73d8b",
  null
  
)

export default component.exports